<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Pengagihan Cecair">
      <div class="table_scrol">
      <div class="w-card__content content-hardcode mb3">
         <w-form v-model="valid" @validate="cari" ref="frm">
          <w-flex class="mt3">
            <w-input style="margin:5px; "
               v-model="pencarian.tarikh_agihan"
               type="date"
               label="Tarikh Agihan"
               />
            
             <w-input style="margin:5px; "
               v-model="pencarian.nama_penerima"
               label="Nama Penerima"
               />
          </w-flex>
        </w-form>
        <w-flex justify-end class="mt2">
            <w-button
                 bg-color="success"
                 @click="cetak()"
                 class="mr2"
              ><w-icon>fal fa-print</w-icon>&nbsp;CETAK</w-button>
            <w-button
                class="mr2"
                v-on:click="resetPencarian()"
                bg-color="warning"
                ><w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
            </w-button>
            <w-button
                class="mr2"
                bg-color="primary"
                @click="$refs.frm.validate()"
                ><w-icon>fal fa-search</w-icon>&nbsp;CARI
            </w-button>
        </w-flex>
      </div>
      <z-table title="Senarai Pengagihan Cecair" :headers="table.headers" :items="table.items" :meta="table.meta">
          <template #button v-if="$zutil.role('1') || $zutil.role('3')">
              <w-button dark class="green--bg ml1" :route="$route('tangki.pengagihan.form',0)" >
                  <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
              </w-button>
          </template>
        <template #header-label="{ header, label, index }">
          <template v-if="header.key == 'action'">
            <!-- <w-icon xs>fal fa-pencil</w-icon> -->
            TINDAKAN
          </template>
          <template v-else>
            {{ label }}
          </template>
        </template>
        <template #item-cell.action="{ item, label, header, index }">
            <w-flex class="flex justify-center">
              <inertia-link :href="$route('tangki.pengagihan.show',item.id)" class="w-button w-button--dark size--md info-dark1--bg"> 
              <w-icon xs class="mr2">fal fa-eye</w-icon>  PAPAR
              </inertia-link>
               &nbsp;
           <w-button  bg-color="warning" v-if="item.hantar!=1 && $zutil.anyRole(['1', '3'])" :route="$route('tangki.pengagihan.form',item.id)" class="be fs-2">
              <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI 
            </w-button>
            &nbsp;
            <w-button class="fs-2" v-if="item.hantar!=1  && $zutil.anyRole(['1', '3'])" bg-color="error-dark1" dark tile @click="destroy1(item.id)">
              <w-icon xs class="mr2">fal fa-trash</w-icon> PADAM
            </w-button>
            </w-flex>
          </template>
      </z-table>
    </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'tangki.pengagihan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Cecair Nitrogen', route: '/tangki' },
        { label: 'Pengagihan Cecair', route: '/tangki/pengagihan' },
      ],
      pencarian: {
         tarikh_agihan: '',
         nama_penerima: '',
         
      },
      tarikh: [],
      nama_penerima: [],
      
    }
  },
  methods: {

    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },


    destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },

    edit() {
          this.form = idx;
          this.form.saveButton = "Kemaskini";
          this.dialog.show = true
      },

    cetak() {
      window.location.href = window.route('tangki.pengagihan.index')+'?tarikh_agihan='+this.pencarian.tarikh_agihan+'&nama_penerima='+this.pencarian.nama_penerima+'&cetak=1';
    },
  
  },

  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
